module.exports = __webpack_public_path__ + "media/images/sale_crm/dep_cal-3f6e3269f64bc72404a02e749cad3f98.svg";